import React from 'react';
import { QuoteMarkIcon, StarIcon } from './Icons';
export const Testimonials = () => {
  const testimonials = [{
    image: 'https://cdn.magicpatterns.com/uploads/jLUVwyA2Mr3sUw2Efbfej3/Emily_R.,_38_Austin,_TX.png',
    quote: 'I stopped feeling like I was imagining everything. For the first time in years, my symptoms actually made sense — and I could finally breathe again.',
    author: 'Emily R., 38 | Austin, TX'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/47NgY2ZxULRfprUFthi3Ag/Sarah_M.,_34_Chicago,_IL.png',
    quote: "I didn't realize how disconnected from myself I had become. I finally felt understood — not just by a method, but by my own body again.",
    author: 'Sarah M., 34 | Chicago, IL'
  }, {
    image: 'https://cdn.magicpatterns.com/uploads/sU29a2V6w28PJJGavkAy1Z/Jennifer_L.,_42_Denver,_CO.png',
    quote: "I had tried so many things. This was the first one that felt gentle. I'm not 'fixed' — I just feel like me again, quietly, day by day.",
    author: 'Jennifer L., 42 | Denver, CO'
  }];
  return <section className="w-full bg-light py-8 md:py-12 px-4 md:px-6" data-id="element-197">
      <div className="max-w-[1200px] mx-auto" data-id="element-198">
        <h2 className="font-playfair text-[28px] md:text-[38px] text-primary text-center mb-6" data-id="element-199">
          Real Women. Real Reconnection.
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-[1000px] mx-auto" data-id="element-200">
          {testimonials.map((testimonial, index) => <div key={index} className="bg-white rounded-[12px] p-6 md:p-7 border-t-[4px] border-medium shadow-[0_4px_16px_rgba(149,125,173,0.12)] flex flex-col" data-id="element-201">
              <div className="flex items-center gap-4 mb-4" data-id="element-202">
                <img src={testimonial.image} alt={testimonial.author} className="w-[64px] h-[64px] rounded-full object-cover flex-shrink-0 border-[2px] border-accent" data-id="element-203" />
                <div className="flex gap-1" data-id="element-204">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} color="#D4AF37" size={18} data-id="element-205" />)}
                </div>
              </div>

              <QuoteMarkIcon color="#E0BBE4" size={36} className="mb-3" data-id="element-206" />

              <p className="font-lato italic text-[16px] text-body leading-[1.7] flex-grow m-0" data-id="element-207">
                "{testimonial.quote}"
              </p>

              <p className="font-lato font-bold text-[14px] text-primary mt-4 m-0" data-id="element-208">
                — {testimonial.author}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
};